import { SiteAnalyzeOffSiteGrid } from "src/app/components";
import { useOrderByMoneySiteOffSiteList } from "src/app/hooks";
import useHistoryByMoneySiteOffSiteList from "src/app/hooks/useHistoryByMoneySiteOffSiteList/useHistoryByMoneySiteOffSiteList";
import { TOffSiteOrderType } from "src/app/types/orders/order";
import { useLocation } from "react-router-dom";

export interface ISiteAnalyzeOffSiteGridContainer {
    moneySiteId?: number;
    orderType: TOffSiteOrderType;
    onRowSelected: (row: any) => void;
    gridRef?: React.RefObject<any>;
    isVisible: boolean;
}

const SiteAnalyzeOffSiteGridContainer = (props: ISiteAnalyzeOffSiteGridContainer) => {
    const { moneySiteId, orderType, onRowSelected, gridRef, isVisible } = props;
    const location = useLocation();
    const isHistoryView = location.pathname.includes("history");

    const { orderByMoneySiteOffSiteList, refresh } = useOrderByMoneySiteOffSiteList(
        orderType,
        moneySiteId
    );

    const { historyByMoneySiteOffSite, refreshHistory, loading } =
        useHistoryByMoneySiteOffSiteList(moneySiteId);

    const handleRowSelection = (event: any) => {
        const selectedRow = event.api.getSelectedRows();
        onRowSelected(selectedRow);
    };

    return (
        <SiteAnalyzeOffSiteGrid
            orderType={orderType}
            rowData={isHistoryView ? historyByMoneySiteOffSite : orderByMoneySiteOffSiteList}
            refreshRowData={isHistoryView ? refreshHistory : refresh}
            onSelectionChanged={handleRowSelection}
            gridRef={gridRef}
            isVisible={isVisible}
            isHistoryView={isHistoryView}
            loading={isHistoryView ? loading : false}
        />
    );
};

export default SiteAnalyzeOffSiteGridContainer;
